import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Times New Roman', // Your desired font
      'Times',
      'serif',
    ].join(','),
    
    // Page Headers (Main titles)
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    
    // Body text
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    
    // Special text styles
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    
    // Button text
    button: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: 'none',
    },
    
    // Caption text
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    
    // Overline text
    overline: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: 'uppercase',
    },
  },

  palette: {
    primary: {
      main: 'rgb(18,82,166)', // Set your desired color for primary palette
    },
    // You can also adjust other theme settings as needed
  },
  
  // Custom component styles
  components: {
    MuiTypography: {
      styleOverrides: {
        // Ensure consistent font family across all typography variants
        root: {
          fontFamily: 'Times New Roman, Times, serif',
        },
      },
    },
  },
});

export default theme;
